import { Stack, Text, ThemeOverride } from "@certn/cascadia";
import { Card, Divider, Icon, Space } from "@certn/cascadia-react";
import { NavLogo } from "@certn/cascadia-react/components/navigation/navigation-top/NavLogo";
import { lightColors } from "@certn/cascadia-tokens";
import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { useBrandingContext } from "../BrandingContext";
import useCustomerGroups from "./useCustomerGroups";

export function Email() {
  const { t } = useTranslation();
  const { processedBrandingAssets } = useBrandingContext();
  const { selectedGroup } = useCustomerGroups();

  return (
    <Stack orientation="vertical" gap="space-2-5" className={styles.container}>
      <Text style="global/heading-medium">{t("Sample")}</Text>
      <ThemeOverride theme="light">
        <Card className={styles.card} type="large">
          <Stack
            orientation="vertical"
            gap="space-5"
            className={styles.emailBody}
          >
            <Stack orientation="horizontal" align="end">
              <div className={styles.logoContainer}>
                <NavLogo
                  logoUrl={processedBrandingAssets?.org_logo_url}
                  darkLogoUrl={processedBrandingAssets?.org_logo_url_dark_mode}
                  type="full"
                />
              </div>
              <Space />
              <img
                alt={t("Powered by Certn")}
                src="https://certn-backend-s3-public-images-ca-central-1-production.s3.ca-central-1.amazonaws.com/powered_by_certn.png"
              />
            </Stack>
            <Text style="global/heading-large" className={styles.textLight}>
              {t(
                "{{selectedGroup}} has sent you a background check request via Certn",
                {
                  selectedGroup: selectedGroup,
                }
              )}
            </Text>
            <Text style="global/body-primary" className={styles.textLight}>
              {t("This request includes:")}
            </Text>
            <Stack orientation="vertical" gap="space-2">
              <Stack orientation="horizontal" gap="space-2">
                <Icon name="check" color="icon-accent-tofino" />
                <Text style="global/body-primary" className={styles.textLight}>
                  {t("One ID")}
                </Text>
              </Stack>
              <Stack orientation="horizontal" gap="space-2">
                <Icon name="check" color="icon-accent-tofino" />
                <Text style="global/body-primary" className={styles.textLight}>
                  {t("Credit report")}
                </Text>
              </Stack>
            </Stack>
            <div className={styles.panel}></div>
            <Card className={styles.messageCard}>
              <Stack orientation="vertical" gap="space-2">
                <Text
                  style="global/body-primary"
                  className={cx(styles.textLight, styles.textBold)}
                >
                  {t("Message from {{selectedGroup}}:", {
                    selectedGroup: selectedGroup,
                  })}
                </Text>
                <Text style="global/body-primary" className={styles.textLight}>
                  {t(
                    "Please provide information and consent needed for the next step in the application process. It'll really make things go quicker. Thanks!"
                  )}
                </Text>
              </Stack>
            </Card>
            <Divider />
          </Stack>
        </Card>
      </ThemeOverride>
    </Stack>
  );
}

const styles = {
  container: css({
    paddingBottom: "var(--space-5)",
    paddingLeft: "var(--space-3)",
    paddingRight: "var(--space-3)",
  }),
  card: css({
    padding: "var(--space-6)",
    backgroundColor: `${lightColors["surface-base"]} !important`,
  }),
  messageCard: css({
    backgroundColor: `${lightColors["background-accent-neutral-weakest"]} !important`,
    paddingTop: "var(--space-3)",
    paddingBottom: "var(--space-3)",
    paddingLeft: "var(--space-4)",
    paddingRight: "var(--space-4)",
  }),
  emailBody: css({
    maxWidth: "500px",
    marginLeft: "auto",
    marginRight: "auto",
  }),
  textLight: css({ color: lightColors["text-base"] }),
  textBold: css({ fontWeight: "600" }),
  textWeak: css({ color: lightColors["text-weak"] }),

  panel: css({
    backgroundColor: lightColors["background-accent-neutral-medium"],
    borderRadius: "var(--border-radius-2)",
    width: "var(--space-24)",
    padding: "var(--space-4)",
  }),
  logoContainer: css({
    width: "fit-content",
    maxWidth: "200px",
    "& img, & svg": {
      width: "auto !important",
      maxWidth: "200px",
      height: "30px",
    },
  }),
};
